const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Admin Users Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('AdminUsers', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/learn/v4/admin-users/:subresource', null, {
    resetting: {params: {subresource: 'resetting'}, method: 'POST', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    findFromQuery: {params: {subresource: 'from-query'}, method: 'POST', isArray: false},
    findFromQueryAndCheck: {params: {subresource: 'from-query-check'}, method: 'POST', isArray: false}
  });

}]);
